import useSWR, {mutate} from "swr";
import {AXIOS} from "../services/api";

const fetcher = async (url) => {
	try {
		const response = await AXIOS.get(url);
		return response.data.data;
	} catch (error) {
		console.error("Error fetching data:", error);
		throw error;
	}
};

export const useFetch = (endpoint, options = {}) => {
	const {data, error, isLoading} = useSWR(endpoint, fetcher, options);

	const customMutate = (revalidate = true) => {
		mutate(endpoint, undefined, revalidate);
	};

	return {data, error, isLoading, mutate: customMutate};
};

export const api = {
	post: async (url, payload) => {
		try {
			mutate(
				url,
				(cacheData) => {
					return [...(cacheData || []), payload];
				},
				false
			);

			const response = await AXIOS.post(url, payload);

			return response.data;
		} catch (error) {
			mutate(
				url,
				(cacheData) => {
					return (cacheData || []).filter((item) => item !== payload);
				},
				false
			);
			throw error;
		}
	},

	put: async (url, payload) => {
		const response = await AXIOS.put(url, payload);
		mutate(url);
		return response.data;
	},

	delete: async (url) => {
		await AXIOS.delete(url);
		mutate(url);
	},
};
